import { Modal } from "react-bootstrap";
import { ActionButton, AltButton } from "../../common/Buttons/Buttons";

export default function BlockRideryCodesModal({ show, action, cancel }) {
  return (
    <Modal size="lg" centered show={show} onHide={() => cancel()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>¿Estas seguro de que deseas continuar?</h5>
        <br />
        <div className="buttons-center-container">
          <AltButton action={cancel} label={"Cancelar"} />
          <ActionButton action={action} label={"Continuar"} />
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
}
